import React from "react";
import { motion } from "framer-motion";
import { Factory, Truck, Warehouse, PackageSearch, Building2, Server } from "lucide-react";
import { useLang } from "../../contexts/LanguageContext";

const ICONS = [Factory, Truck, Warehouse, PackageSearch, Building2, Server];

export default function Industries() {
  const { t } = useLang();

  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative py-20 md:py-28 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.24em] uppercase font-bold text-[#1E5BD6]">
            <span className="h-px w-8 bg-[#1E5BD6]" />
            {t.industries.label}
          </div>
          <h2
            data-testid="industries-title"
            className="mt-5 font-heading font-bold text-slate-900 text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]"
          >
            {t.industries.title}
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
          {t.industries.items.map((item, i) => {
            const Icon = ICONS[i] || Factory;
            return (
              <motion.div
                key={item}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.45, delay: i * 0.05 }}
                data-testid={`industry-${i}`}
                className="group bg-white border border-slate-200 rounded-sm p-5 lg:p-6 hover:border-[#1E5BD6]/50 hover:-translate-y-0.5 transition-all duration-200"
              >
                <Icon className="h-5 w-5 text-[#1E5BD6]" />
                <div className="mt-4 font-heading font-bold text-sm sm:text-base text-slate-900 leading-tight">
                  {item}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
